import { MixpanelEvent } from './mixpanel-events'
import { CREATE_SAFE_EVENTS } from './events/createLoadSafe'
import { WALLET_EVENTS } from './events/wallet'
import { SAFE_APPS_EVENTS } from './events/safeApps'
import { POSITIONS_EVENTS } from './events/positions'
import { PORTFOLIO_EVENTS } from './events/portfolio'
import { STAKE_EVENTS } from './events/stake'
import { EARN_EVENTS } from './events/earn'
import { WALLETCONNECT_EVENTS } from './events/walletconnect'
import { TX_LIST_EVENTS } from './events/txList'
import { SWAP_EVENTS } from './events/swaps'
import { TERMS_EVENTS } from './events/terms'
import { EXPLORE_POSSIBLE_EVENTS, OVERVIEW_EVENTS } from './events/overview'
import { NESTED_SAFE_EVENTS } from './events/nested-safes'
import { SAFE_SHIELD_EVENTS } from './events/safe-shield'
import { HYPERNATIVE_EVENTS } from './events/hypernative'
import { TX_EVENTS } from './events/transactions'

// If an event is mapped here, it will be tracked in Mixpanel
export const GA_TO_MIXPANEL_MAPPING: Record<string, string> = {
  [CREATE_SAFE_EVENTS.CREATED_SAFE.action]: MixpanelEvent.SAFE_CREATED,
  [CREATE_SAFE_EVENTS.ACTIVATED_SAFE.action]: MixpanelEvent.SAFE_ACTIVATED,
  [WALLET_EVENTS.CONNECT.action]: MixpanelEvent.WALLET_CONNECTED,
  [SAFE_APPS_EVENTS.OPEN_APP.action]: MixpanelEvent.SAFE_APP_LAUNCHED,
  [POSITIONS_EVENTS.POSITION_EXPANDED.action]: MixpanelEvent.POSITION_EXPANDED,
  [POSITIONS_EVENTS.POSITIONS_VIEW_ALL_CLICKED.action]: MixpanelEvent.POSITIONS_VIEW_ALL_CLICKED,
  [POSITIONS_EVENTS.EMPTY_POSITIONS_EXPLORE_CLICKED.action]: MixpanelEvent.EMPTY_POSITIONS_EXPLORE_CLICKED,
  [PORTFOLIO_EVENTS.PORTFOLIO_REFRESH_CLICKED.action]: MixpanelEvent.PORTFOLIO_REFRESH_CLICKED,
  [STAKE_EVENTS.STAKE_VIEWED.action]: MixpanelEvent.STAKE_VIEWED,
  [EARN_EVENTS.EARN_VIEWED.action]: MixpanelEvent.EARN_VIEWED,
  [WALLETCONNECT_EVENTS.CONNECTED.action]: MixpanelEvent.WC_CONNECTED,
  [TX_LIST_EVENTS.CSV_EXPORT_CLICKED.action]: MixpanelEvent.CSV_TX_EXPORT_CLICKED,
  [TX_LIST_EVENTS.CSV_EXPORT_SUBMITTED.action]: MixpanelEvent.CSV_TX_EXPORT_SUBMITTED,
  [SWAP_EVENTS.OPEN_SWAPS.action]: MixpanelEvent.NATIVE_SWAP_VIEWED,
  [TERMS_EVENTS.ACCEPT_SAFE_LABS_TERMS.action]: MixpanelEvent.SAFE_LABS_TERMS_ACCEPTED,
  [OVERVIEW_EVENTS.SIDEBAR_CLICKED.action]: MixpanelEvent.SIDEBAR_CLICKED,
  [OVERVIEW_EVENTS.NEW_TRANSACTION.action]: MixpanelEvent.SIDEBAR_CLICKED,
  [OVERVIEW_EVENTS.SIDEBAR.action]: MixpanelEvent.SIDEBAR_CLICKED,
  [OVERVIEW_EVENTS.WHATS_NEW.action]: MixpanelEvent.SIDEBAR_CLICKED,
  [OVERVIEW_EVENTS.HELP_CENTER.action]: MixpanelEvent.SIDEBAR_CLICKED,
  [OVERVIEW_EVENTS.SHOW_QR.action]: MixpanelEvent.SIDEBAR_CLICKED,
  [OVERVIEW_EVENTS.COPY_ADDRESS.action]: MixpanelEvent.SIDEBAR_CLICKED,
  [OVERVIEW_EVENTS.OPEN_EXPLORER.action]: MixpanelEvent.SIDEBAR_CLICKED,
  [NESTED_SAFE_EVENTS.OPEN_LIST.action]: MixpanelEvent.SIDEBAR_CLICKED,
  [HYPERNATIVE_EVENTS.GUARDIAN_BANNER_VIEWED.action]: MixpanelEvent.GUARDIAN_BANNER_VIEWED,
  [HYPERNATIVE_EVENTS.GUARDIAN_FORM_VIEWED.action]: MixpanelEvent.GUARDIAN_FORM_VIEWED,
  [HYPERNATIVE_EVENTS.GUARDIAN_FORM_STARTED.action]: MixpanelEvent.GUARDIAN_FORM_STARTED,
  [HYPERNATIVE_EVENTS.GUARDIAN_FORM_SUBMITTED.action]: MixpanelEvent.GUARDIAN_FORM_SUBMITTED,
  [HYPERNATIVE_EVENTS.SECURITY_REPORT_CLICKED.action]: MixpanelEvent.SECURITY_REPORT_CLICKED,
  [HYPERNATIVE_EVENTS.GUARDIAN_BANNER_DISMISSED.action]: MixpanelEvent.GUARDIAN_BANNER_DISMISSED,
  [EXPLORE_POSSIBLE_EVENTS.EXPLORE_POSSIBLE_CLICKED.action]: MixpanelEvent.EXPLORE_POSSIBLE_CLICKED,
  [OVERVIEW_EVENTS.OPEN_EURCV_BOOST.action]: MixpanelEvent.EURCV_BOOST_BANNER_CLICKED,
  [OVERVIEW_EVENTS.HIDE_EURCV_BOOST_BANNER.action]: MixpanelEvent.EURCV_BOOST_BANNER_DISMISSED,
  [SAFE_SHIELD_EVENTS.TRANSACTION_STARTED.action]: MixpanelEvent.TRANSACTION_STARTED,
  [SAFE_SHIELD_EVENTS.RECIPIENT_DECODED.action]: MixpanelEvent.TRANSACTION_RECIPIENT_DECODED,
  [SAFE_SHIELD_EVENTS.CONTRACT_DECODED.action]: MixpanelEvent.TRANSACTION_CONTRACT_DECODED,
  [SAFE_SHIELD_EVENTS.THREAT_ANALYZED.action]: MixpanelEvent.TRANSACTION_THREAT_ANALYZED,
  [SAFE_SHIELD_EVENTS.SIMULATED.action]: MixpanelEvent.TRANSACTION_SIMULATED,
  [TX_EVENTS.EXECUTE.action]: MixpanelEvent.TRANSACTION_EXECUTED,
  [TX_EVENTS.EXECUTE_VIA_PARENT.action]: MixpanelEvent.TRANSACTION_EXECUTED_VIA_PARENT,
  [TX_EVENTS.EXECUTE_IN_PARENT.action]: MixpanelEvent.TRANSACTION_EXECUTED_IN_PARENT,
  [TX_EVENTS.EXECUTE_VIA_ROLE.action]: MixpanelEvent.TRANSACTION_EXECUTED_VIA_ROLE,
  [TX_EVENTS.CREATE.action]: MixpanelEvent.TRANSACTION_SUBMITTED,
  [TX_EVENTS.CREATE_VIA_ROLE.action]: MixpanelEvent.TRANSACTION_SUBMITTED,
  [TX_EVENTS.CREATE_VIA_PROPOSER.action]: MixpanelEvent.TRANSACTION_SUBMITTED,
  [TX_EVENTS.CREATE_VIA_PARENT.action]: MixpanelEvent.TRANSACTION_SUBMITTED,
  [TX_EVENTS.CREATE_VIA_SPENDING_LIMTI.action]: MixpanelEvent.TRANSACTION_SUBMITTED,
  [TX_EVENTS.EXECUTE_VIA_SPENDING_LIMIT.action]: MixpanelEvent.TRANSACTION_EXECUTED,
  [OVERVIEW_EVENTS.TRUSTED_SAFES_ADDED.action]: MixpanelEvent.TRUSTED_SAFE_ADDED,
  [OVERVIEW_EVENTS.TRUSTED_SAFES_REMOVED.action]: MixpanelEvent.TRUSTED_SAFE_REMOVED,
}

// Maps GA labels (lowercase) to Mixpanel properties (Title Case)
export const GA_LABEL_TO_MIXPANEL_PROPERTY: Record<string, string> = {
  asset: 'Assets',
  dashboard_assets: 'Home',
  sidebar: 'Sidebar',
  newTransaction: 'New Transaction',
}
